define('common/ko/extension/guard',['knockout'], function (ko) {
    ko.extenders.guard = function(source, guardFlagSet) {

        var lastValue = ko.observable(),
            subscription;

        return ko.pureComputedArray(function() {
            if(lastValue()) lastValue();

            if(!subscription)
                subscription = source.subscribe(function() {
                    if(ko.unwrap(guardFlagSet)) return;
                    lastValue(source());
                });
            var value = source.peek();
            lastValue(value);
            return value;
        });

    };
});

